import * as React from "react";
import {Button, TextInput} from "@vebox/etui-core";


import "./styles.scss";
import {themeDefaultValues} from "../../../../../index";
import {SingleData} from "../../builder/models";
import {getFormattedDate} from "../../../../../ReadAndWrite/ReadAndWrite/utils";
import {Display} from "../../../../../components/Display";

interface CommandWithValueProps {
    name: string;
    equipmentGuid: string;
    value: SingleData;
    buttonIconHref?: string;
    onClick: (equipmentGuid) => void;
    editable: boolean
}

export const CommandWithValue: React.FC<CommandWithValueProps> = ({
                                                                      name,
                                                                      onClick,
                                                                      buttonIconHref,
                                                                      value,
                                                                      equipmentGuid,
                                                                      editable
                                                                  }) => {
    return (
        <div className={"command-with-value"}>
            <TextInput
                readOnly={true}
                value={value?.value?.value ?? ""}
                label={name}
                styles={{
                    root: {},
                    label: {
                        fontSize: 15,
                    },
                    input: {
                        boxSizing: "border-box",
                        fontSize: 18,
                    },
                }}
            />
            <Display isVisible={editable}>
                <Button
                    variant={"secondary"}
                    onClick={() => onClick(equipmentGuid)}
                    shape={"circle"}
                    styles={{
                        root: {
                            p: 10,
                            width: themeDefaultValues.buttonWidth,
                            height: themeDefaultValues.buttonHeight
                        }
                    }}
                >
                    <span className="material-icons-outlined">{buttonIconHref}</span>
                </Button>
            </Display>
        </div>
    );
};